import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function startCheckout(lookupKey, extra = {}) {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: lookupKey,
    quantity: 1,
    origin_url: window.location.origin,
    ...extra,
  });
  window.location.href = data.checkout_url;
}
